<template>
  <div id="content-wrapper">
    <b-tabs content-class="mt-3">
      <b-tab
        :active="activeTab === `#${GROUP_TAB.THONG_TIN_GROUP}`"
        @click="changeCurrentTab(GROUP_TAB.THONG_TIN_GROUP)"
        title="Thông tin nhóm người dùng"
      >
        <div class="box box-form pb-5">
          <FormGroup
            :form="chiTietGroup"
            :readonly="true"
            ref="cap-nhat-group"
          />
          <div class="d-flex justify-content-end">
            <base-button  button="Cập nhật" @click="goToSua()" v-if="hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.SUA)"
            ></base-button>
            <base-button button="Đóng" @click="boQua()"></base-button>
          </div>
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${GROUP_TAB.NGUOI_DUNG}`"
        @click="changeCurrentTab(GROUP_TAB.NGUOI_DUNG)"
        title="Người dùng"
      >
        <div class="box box-form">
          <DanhSachNguoiDungTheoGroup
            :chiTietGroup="chiTietGroup"
            :key="`thuoc-group-${chiTietGroup.Id}`"
            :readonly="true"
            ref="danhSachNguoiDungThuocGroup"
          />
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${GROUP_TAB.VAI_TRO}`"
        @click="changeCurrentTab(GROUP_TAB.VAI_TRO)"
        title="Vai trò"
      >
        <div class="box box-form">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <DanhSachVaiTroTheoGroup
            :chiTietGroup="chiTietGroup"
            :key="`thuoc-group-${chiTietGroup.Id}`"
            :readonly="true"
            :appId="internalAppId"
            ref="danhSachVaiTroTheoGroup"
          />
        </div>
      </b-tab>

      <b-tab
        :active="activeTab === `#${GROUP_TAB.QUYEN}`"
        @click="changeCurrentTab(GROUP_TAB.QUYEN)"
        title="Phân quyền"
      >
        <div class="box box-form">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <DanhSachQuyenTrongGroup
            :chiTietNguoiDung="chiTietGroup"
            :key="`thuoc-group-${chiTietGroup.Id}`"
            :appId="internalAppId"
            :readonly="true"
            ref="danhSachQuyenTrongGroup"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BO_QUA_BUTTON_LABEL,
  ROUTE_NAME,
  GROUP_TAB,
  PERMISSION_NAME,
} from "@/constants/constants";
import FormGroup from "@/components/pages/quan-tri-he-thong/group/FormGroup";
import DanhSachNguoiDungTheoGroup from "@/components/pages/quan-tri-he-thong/nguoi-dung/DanhSachNguoiDungTheoGroup";
import DanhSachVaiTroTheoGroup from "@/components/pages/quan-tri-he-thong/vai-tro/DanhSachVaiTroTheoGroup";
import DanhSachQuyenTrongGroup from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenTrongGroup";
import { mapGetters } from "vuex";
import { hasPermissionUser } from "@/utils/permissionUtils";
export default {
  name: "XemGroup",
  data() {
    return {
      PERMISSION_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalChiTietGroup: {},
      activeTab: GROUP_TAB.THONG_TIN_GROUP,
      GROUP_TAB: GROUP_TAB,
      internalAppId: null,
    };
  },
  components: {
    FormGroup,
    DanhSachNguoiDungTheoGroup,
    DanhSachVaiTroTheoGroup,
    DanhSachQuyenTrongGroup,
  },
  computed: {
    ...mapGetters({
      chiTietGroup: "group/chiTietGroup",
      danhSachApp: "app/tatCaApp",
    }),
    danhSachAppNoiBo() {
      if (
        this.danhSachApp &&
        this.chiTietGroup &&
        this.chiTietGroup.applicationIds
      ) {
        return this.danhSachApp.filter((x) =>
          this.chiTietGroup.applicationIds.includes(x.id)
        );
      } else {
        return [];
      }
    },
  },
  created() {
    this.activeTab = location.hash;
    this.$store.dispatch("group/layChiTietGroup", {
      id: this.$router.currentRoute.params.id,
    });
  },
  watch: {
    chiTietGroup: {
      handler() {
        this.internalChiTietGroup = Object.assign(
          {},
          this.internalChiTietGroup,
          this.chiTietGroup
        );
        if (
          this.chiTietGroup.applicationIds &&
          this.chiTietGroup.applicationIds.length === 1
        ) {
          this.internalAppId = this.chiTietGroup.applicationIds[0];
        }
      },
    },
  },
  methods: {
    hasPermissionUser,
    changeCurrentTab(currentTab) {
      this.$router
        .push({
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_GROUP,
          hash: `#${currentTab}`,
        })
        .catch(() => {});
    },
    boQua() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME,
      });
    },
    goToSua() {
      window.location.href = `/${ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME}/${this.$router.currentRoute.params.id}`;
    },
  },
};
</script>

